var d3 = Object.assign(
  {},
  require('d3-shape'),
  require('d3-selection'),
  require('d3-axis'),
  require('d3-scale'),
  require('d3-array'),
  require('d3-drag'),
);


export const cashFlowDiagram = function (results: any, number: number) {
//eslint-disable-line
  var svgWidth = 1135;
  var svgHeight = 500;
  var svg = d3.select("#cashFlowGraph_" + number);

  // var svg = canvas.append("svg")
  //   .attr("width", svgWidth)
  //   .attr("height", svgHeight)
  //   .attr("class", "cashFlow_" + number);

  var margin = {top: 30, right: 250, bottom: 60, left: 150},
    width = svgWidth - margin.left - margin.right,
    height = svgHeight - margin.top - margin.bottom,
    group = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  var padding = 10;

  var flattenedData: any = [];
  var groupedData: any = [];

  results.forEach(function (result: any) {
    var activityData = {
      x: result.startYear,
      y: result.agencyConstructionCost,
      color: result.color,
      category: result.category,
      serviceLife: result.serviceLife_yrs,
      structuralLife: result.structuralLife_yrs,
      userWorkzoneCost: result.userWorkzoneCost
    };

    // object contains service life
    var serviceLifeData = {
      x: parseFloat(result.serviceLife_yrs) + parseFloat(result.startYear),
      y: 0,
      color: result.color,
      category: result.category,
      serviceLife: true
    };

    flattenedData.push(activityData, serviceLifeData);

    groupedData.push({activityData: activityData, serviceLifeData: serviceLifeData});
  });

// vertical and horizontal scale
  var x = d3.scaleLinear()
    .domain([0, d3.max(flattenedData, function (d: any) {
      return d.x;
    })])
    .rangeRound([0, width]);
  var y = d3.scaleLinear()
    .domain([0, d3.max(flattenedData, function (d: any) {
      return d.y;
    })])
    .rangeRound([height, 0]);

// x axis
  group.append("g")
    .attr("class", "axis")
    .attr("transform", "translate(0," + height + ")")
    .call(d3.axisBottom(x));
// x axis label
  svg.append("text")
    .style("font-size", "16px")
    .attr("font-family", "Tahoma")
    .attr("text-anchor", "middle")
    .text("Years")
    .attr("transform", "translate (" + (width / 2 + margin.left) + ", " + (height + margin.top + margin.bottom / 1.25) + ")");

// y axis
  group.append("g")
    .attr("class", "axis")
    .call(d3.axisLeft(y));
// y axis label
  svg.append("text")
    .style("font-size", "16px")
    .attr("font-family", "Tahoma")
    .attr("text-anchor", "middle")
    .text("Agency Costs ($1000)")
    .attr("transform", "translate (" + margin.left / 4 + "," + (margin.top + height / 2) + ") rotate(-90)");

  d3.selectAll(".tick > text")
    .style("font-size", "2em");

// //tip on hover
//   var tip = d3.tip()
//     .attr('class', 'd3-tip')
//     .offset([-10, 0])
//     .html(function (d: any) {
//       if (app.data.userCostComputationMethod === "Calculated") {
//         return "<span>Year: " + d.x + "<br>Agency Cost: $" + d.y + "<br>Service Life: " + d.serviceLife_yrs + " years<br>Structural Life: " + d.structuralLife_yrs + " years</span>";
//       }
//       return "<span>Year: " + d.x + "<br>Agency Cost: $" + d.y + "<br>User Cost: $" + d.userWorkzoneCost + "<br>Service Life: " + d.serviceLife_yrs + " years<br>Structural Life: " + d.structuralLife_yrs + " years</span>";
//     });
//   group.call(tip);

//Add bar charts
  group.selectAll(".bar")
    //@ts-ignore
    .data(groupedData.map(function (activity) {
      return activity.activityData;
    }))
    .enter().append("rect")
  // .on("mouseover", tip.show)
  // .on("mouseout", tip.hide)
    .attr("class", "bar")
    .attr("x", function (d: any) {
      return x(d.x);
    })
    .attr("y", function (d: any) {
      return y(d.y);
    })
    .attr("width", 10)//y(width - margin.left - margin.right)/data.length)
    .attr("height", function (d: any) {
      return height - y(d.y);
    })
    .attr("fill", function (d: any) {
      return d.color;
    });

// Add dotted lines for service years
  group.selectAll('.serviceYearLine')
    .data(groupedData.map(function (activity: any) {
      return activity.serviceLifeData;
    }))
    .enter()
    .append("line")
    .attr("x1", function (d: any) {
      return x(d.x);
    })
    .attr("y1", 0)
    .attr("x2", function (d: any) {
      return x(d.x);
    })
    .attr("y2", height)
    .attr("stroke", function (d: any) {
      return d.color;
    })
    .attr('class', 'legendNote')
    .style("stroke-dasharray", "5,5")
    .attr("stroke-width", 2)
    .attr("fill", "none");

// make legend
  var legendTopMargin = 25;
  var legendLeftMargin = 20;
  var legendBoxSize = 20;
  var legendBoxMargin = 5;
  var legendTextMargin = 10;

  var legendGroup = svg.append("g")
    .attr("text-anchor", "end")
    .style("font-size", "14px")
    .attr("font-family", "Tahoma")
    .attr("class", "legend")
    .selectAll(".legend")
    .data(groupedData)
    .enter().append("g")
    .attr("transform", function (d: any, i: number) {
      return "translate(" + (svgWidth - legendLeftMargin) + "," + (i * (legendBoxSize * 2 + legendBoxMargin) + legendTopMargin) + ")";
    });

// Append colored box for activity
  legendGroup.append("rect")
    .attr("width", legendBoxSize)
    .attr("height", legendBoxSize)
    .attr("fill", function (d:any, i:number) {
      return d.activityData.color;
    });

// Append text for activity
  legendGroup.append("text")
    .text(function (d: any) {
      return d.activityData.category;
    })
    .attr("alignment-baseline", "central")
    .attr("transform", "translate (" + (-1 * legendTextMargin) + "," + legendBoxSize * 0.5 + ")");

// Append legend dotted line
  legendGroup.append("line")
    .attr("x1", 0)
    .attr("y1", (legendBoxSize * 1.5 + legendBoxMargin * 0.5))
    .attr("x2", 0 + legendBoxSize)
    .attr("y2", (legendBoxSize * 1.5 + legendBoxMargin * 0.5))
    .attr("stroke", function (d: any) {
      return d.serviceLifeData.color;
    })
    .style("stroke-dasharray", "5,5")
    .attr("stroke-width", 2)
    .attr("fill", "none");

// Append legend text for dotted line
  legendGroup.append("text")
    .text(function (d: any) {
      return d.activityData.category + " End Service Life";
    })
    .attr("alignment-baseline", "central")
    .attr("transform", "translate (" + (-1 * legendTextMargin) + "," + legendBoxSize * 1.5 + ")");
}
